import React, { useEffect, useState } from "react";
import T from "prop-types";
import { LINE_ITEMS } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import { Col, Row } from "react-bootstrap";
import {
  INVENTORY_TRANSFER_ORDER,
  MRO_ITEM,
  RO_ITEM,
  SO_ITEM
} from "MODULES/Orders/shared/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { SHIP_MULTIPLE_ITEM_IDS } from "MODULES/Shipping/constants";
import { SimpleCopy } from "MODULES/Shipping/components/Dashboard/Create/Form";
import { INVENTORIES } from "MODULES/inventories/constants";

function ShipMultipleRecordsTable({
  orderId,
  getInitialFieldValue,
  setFieldValue,
  type
}) {
  if (![SO_ITEM, RO_ITEM, MRO_ITEM, INVENTORY_TRANSFER_ORDER].includes(type))
    return null;
  const [lineItems, setLineItems] = useState([]);
  const [selectedLineItems, setSelectedLineItems] = useState(
    getInitialFieldValue(SHIP_MULTIPLE_ITEM_IDS) || []
  );
  const [selectedAll, setSelectedAll] = useState(false);

  const onItemSelected = item => {
    let setItems = [];
    if (selectedLineItems.includes(item.id)) {
      const index = selectedLineItems.indexOf(item.id);
      selectedLineItems.splice(index, 1);
      setItems = selectedLineItems;
      setSelectedLineItems(setItems);
    } else {
      setItems = selectedLineItems.concat(item.id);
      setSelectedLineItems(setItems);
    }
    setFieldValue(SHIP_MULTIPLE_ITEM_IDS)(setItems);
  };

  const selectAll = () => {
    if (selectedAll) {
      setSelectedLineItems([]);
      setFieldValue(SHIP_MULTIPLE_ITEM_IDS)([]);
      setSelectedAll(false);
    } else {
      const allItems = lineItems.map(l => l.id);
      setSelectedLineItems(allItems);
      setFieldValue(SHIP_MULTIPLE_ITEM_IDS)(allItems);
      setSelectedAll(true);
    }
  };

  const uriMap = {
    [RO_ITEM]: "repairOrders",
    [MRO_ITEM]: "managedRepairOrders",
    [SO_ITEM]: "salesOrders",
    [INVENTORY_TRANSFER_ORDER]: "transfers"
  };

  useEffect(
    () => {
      api[uriMap[type]].show(orderId, "lines_no_details").then(({ data }) => {
        const items = data.line_items || data.results;
        setLineItems(items.filter(l => !l.shipped && !l.cancelled));
        if (items.length === 1) {
          onItemSelected(items[0]);
        }
        return function cleanup() {};
      });
    },
    [orderId]
  );

  if (lineItems.length === 0) return null;

  const renderRow = (lineItem, i) => (
    <tr key={i}>
      <td>{i + 1}</td>
      <td style={{ marginBottom: "6px" }}>
        <input
          name={LINE_ITEMS}
          type="checkbox"
          disabled={lineItems.length === 1}
          checked={selectedLineItems.includes(lineItem.id)}
          onChange={() => onItemSelected(lineItem)}
        />
      </td>
      <td style={{ position: "relative" }}>
        {lineItem.part.part_number}
        <SimpleCopy value={lineItem.part.part_number} />
      </td>
      <td>{lineItem.serial_number}</td>
      <td>
        {lineItem.condition && INVENTORIES.condition[lineItem.condition].abbrev}
      </td>
      <td>{lineItem.quantity}</td>
      <td>{lineItem.part.description}</td>
    </tr>
  );

  return (
    <Row className="row-col-gutters-half">
      <Col md={12}>
        <h4>Parts</h4>
        <table className="table table-striped table-hover table-numbered">
          <thead>
            <tr>
              <th />
              <th>
                <input
                  name="line_items"
                  type="checkbox"
                  disabled={lineItems.length === 1}
                  onChange={selectAll}
                  checked={selectedAll}
                />
                &nbsp;&nbsp;Select All
              </th>
              <th>Part Number</th>
              <th>Serial#</th>
              <th>Cd</th>
              <th>QTY</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>{lineItems.map((inv, idx) => renderRow(inv, idx))}</tbody>
        </table>
      </Col>
    </Row>
  );
}

ShipMultipleRecordsTable.propTypes = {
  orderId: T.number,
  type: T.string,
  setFieldValue: T.func,
  getInitialFieldValue: T.func
};

export default withFieldAccessors(ShipMultipleRecordsTable);



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Create/ShipMultipleRecordsTable.jsx